import axios from '@/request';
import * as model from '@/models/merchant.models';
/** 查询当前登录用户的角色 */
export async function userRoleV2UsingGET(params: { caller?: string }) {
  const paramArr = [];
  for (const key in params) {
    paramArr.push(
      `${key}=${
        typeof (params as any)[key] === 'string'
          ? (params as any)[key]
          : JSON.stringify((params as any)[key])
      }`
    );
  }
  return await axios.get<model.IMessageUserRoleVO>(
    `/rest/op/vc/merchant/shopMember/userRoleV2?${paramArr.join('&')}`
  );
}
/** 查询商户信息 */
export async function merchantInfoGET(params: { userId: string }) {
  const result = await axios.get<model.IMessageMerchantInfoVO>(
    `/rest/merchant/home/merchantInfo?userId=${params.userId}`
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}

/** 查询店铺列表V2 */
export async function listStoreInfoPOST(params: {
  pageNum: number;
  pageSize: number;
  processStatusValue: number;
}) {
  const result = await axios.post<model.IMessageMerchantInfoVO>(
    '/rest/merchant/apicenter/queryMerchantPoiInfo',
    params
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}

/** 查询店铺列表各类型数量 */
export async function getStoreCountInfo() {
  const result = await axios.get(
    '/rest/merchant/apicenter/queryMerchantPoiCensorAmount'
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}

/** 更新门店信息 */
export async function updateMaterialInfoPOST(params: {
  merchantId: number | string;
  merchantName: string;
}) {
  const result = await axios.post<model.IMessageMerchantInfoVO>(
    '/rest/merchant/app/invest/updateMaterialInfo',
    params
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}
/** 查询店铺资质 */
export async function certInfoGET() {
  const result = await axios.get<model.IMessageCertInfoVO>(
    '/rest/merchant/apicenter/invest/merchant/cert/detail'
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}

// 获取当前用户最新资源标识
export async function getUserResourcesGET() {
  const result = await axios.get<model.IMessageUserResourcesVO>(
    '/rest/merchant/auth/getUserResources?platform=2'
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}
// 获取用户进件路由
export async function pinganListGET() {
  const result = await axios.get<model.IMessagePinganListVO>(
    '/rest/settlement/finance/gateway/pingan/list'
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}
// 删除微信进件
export async function deleteWechat(applicationId?: string) {
  const url = '/rest/settlement/finance/gateway/pingan/application/delete';
  const result = await axios.post(url, { applicationId });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}
// 获取用户主体列表
export async function subjectListGET(qualificationType: 'wechat' | 'alipay') {
  const result = await axios.get<model.IMessageSubjectListVO>(
    `/rest/settlement/finance/gateway/subject/list?qualificationType=${qualificationType}`
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}
// 资质升级
export async function qualificationUpdateGET(qualificationId: string | number) {
  const result = await axios.get<model.IMessageUpgradeVO>(
    `/rest/settlement/finance/gateway/qualification/update?qualificationId=${qualificationId}`
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}
// 去激活
export async function qualificationActiveGET(
  qualificationId: string | number,
  applicationId: string | number
) {
  const result = await axios.get<model.IMessageUpgradeVO>(
    `/rest/settlement/finance/gateway/qualification/active?qualificationId=${qualificationId}&applicationId=${applicationId}`
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data;
}

/** 与结算换支付中台的code */
export async function getInputSubjectId(params: model.userRoleReq) {
  const url = '/rest/settlement/finance/account/getInputSubjectId';
  const result = await axios.post(url, params);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result.data?.data || {};
}

/** 获商家电话信息 https://locallife-apicenter.staging.kuaishou.com/open/doc/api?name=rest.merchant.apicenter.queryMerchantTelShow&version=1 */
export async function queryMerchantTelShow() {
  const result =
    await axios.get<model.RestMerchantApicenterQueryMerchantTelShowResponse>(
      '/rest/merchant/apicenter/queryMerchantTelShow'
    );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result?.data;
}

/** 发送验证码 https://locallife-apicenter.staging.kuaishou.com/open/doc/api?name=rest.merchant.apicenter.sendVerifyCodeOfMerchantTel&version=1 */
export async function sendVerifyCodeOfMerchantTel(phoneNumber: string) {
  const result =
    await axios.post<model.RestMerchantApicenterSendVerifyCodeOfMerchantTelResponse>(
      'rest/merchant/apicenter/sendVerifyCodeOfMerchantTel',
      { phoneNumber }
    );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result?.data;
}

/** 修改商家电话 https://locallife-apicenter.staging.kuaishou.com/open/doc/api?name=rest.merchant.apicenter.modifyMerchantTel&version=1 */
export async function modifyMerchantTel(params: {
  param: model.RestMerchantApicenterModifyMerchantTelRequest;
}) {
  const result =
    await axios.post<model.RestMerchantApicenterModifyMerchantTelResponse>(
      `/rest/merchant/apicenter/modifyMerchantTel`,
      { ...params.param }
    );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result?.data;
}

/** 删除商家电话 https://locallife-apicenter.staging.kuaishou.com/open/doc/api?name=rest.merchant.apicenter.modifyMerchantTel&version=1*/
export async function deleteMerchantTelInfo(params: {
  param: model.RestMerchantApicenterDeleteMerchantTelInfoRequest;
}) {
  const result = await axios.post(
    `/rest/merchant/apicenter/deleteMerchantTelInfo`,
    { ...params.param }
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result?.data;
}

/** 新增商家电话 https://locallife-apicenter.staging.kuaishou.com/open/doc/api?name=rest.merchant.apicenter.modifyMerchantTel&version=1*/
export async function createMerchantInfoTel(params: {
  param: model.RestMerchantApicenterModifyMerchantTelRequest;
}) {
  const result = await axios.post(
    `/rest/merchant/apicenter/createMerchantInfoTel`,
    { ...params.param }
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return result?.data;
}
